<template>
  <transition name="fade">
    <vs-button
      v-if="showButton"
      type="gradient"
      icon-pack="feather"
      icon="icon-arrow-up"
      class="button__back-to-top"
      @click="backToTop()"
    />
  </transition>
</template>


<script>
export default {
  name: "BackToTop",
  data() {
    return {
      showButton: false,
      visibleoffset: 500,
    };
  },
  methods: {
    catchScroll() {
      this.showButton = window.pageYOffset > this.visibleoffset;
    },
    backToTop() {
      // this.intervalId = setInterval(() => {
      //   if (window.pageYOffset === 0) {
      //     clearInterval(this.intervalId)
      //   }
      //   window.scroll(0, window.pageYOffset - window.pageYOffset / 2)
      // }, 10)



      // const currentScroll =
      //   document.documentElement.scrollTop || document.body.scrollTop;
      // if (currentScroll > 0) {
      //   setTimeout(() => {
      //     window.scrollTo(0, Math.floor(currentScroll - currentScroll / 10));
      //     this.backToTop();
      //   }, 10);
      // }

       window.scroll({
        behavior: 'smooth',
        left: 0,
        top: 0
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.catchScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.catchScroll);
  },
};
</script>

<style scoped lang="scss">
.button__back-to-top {
  position: fixed;
  z-index: 1000;
  right: 1%;
  bottom: 9%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
